<h3 class="mb15">Rest API Not Available</h3>
<p>Please <a (click)="_redirectToHC()">check the following link</a> to fix the issue and retry the connection afterwards.</p>
